import React from "react";
import { useNavigate } from "react-router-dom";
import { BOND_PLAY_GAME_TYPES, getBondPlayGameHref } from "../../utils/bondPlayGameTypes";
import { BOND_PLAY_GAME_ICONS } from "../../utils/sidebarNavIcons";

const BondPlayGameTypeRail = ({ activeGameId, onSelectInline, className = "" }) => {
  const navigate = useNavigate();

  const handleSelect = (type) => {
    if (type.id === activeGameId) return;

    if (type.route === "/app/bond-play" && onSelectInline) {
      onSelectInline(type.id);
      return;
    }

    navigate(getBondPlayGameHref(type));
  };

  return (
    <aside className={`bplay-rail${className ? ` ${className}` : ""}`} aria-label="Game type">
      <div className="bplay-rail-label">Games</div>
      <div className="bplay-rail-list">
        {BOND_PLAY_GAME_TYPES.map((type) => {
          const active = type.id === activeGameId;
          const GameIcon = BOND_PLAY_GAME_ICONS[type.id];
          return (
            <button
              key={type.id}
              type="button"
              className={`bplay-rail-item ${active ? "active" : ""}`}
              style={{
                "--rail-accent": type.accent,
                "--rail-accent-bg": type.accentBg,
                "--rail-accent-border": type.accentBorder,
                "--rail-accent-glow": type.accentGlow,
              }}
              onClick={() => handleSelect(type)}
            >
              <span
                className="bplay-rail-icon"
                style={{ color: type.accent, background: type.accentBg }}
              >
                {GameIcon ? <GameIcon size={16} strokeWidth={2.25} aria-hidden /> : null}
              </span>
              <div className="bplay-rail-text">
                <span className="bplay-rail-name">{type.short}</span>
                <span className={`bplay-rail-status ${type.status === "live" ? "is-live" : "is-soon"}`}>
                  <i className="bplay-rail-status-dot" aria-hidden />
                  {type.status === "live" ? "Live" : "Soon"}
                </span>
              </div>
            </button>
          );
        })}
      </div>
    </aside>
  );
};

export default BondPlayGameTypeRail;
